import React from 'react';
import UPLogo from 'assets/images/upfleet_logo.png';

import { useStyle } from './styles';

function Loader() {
  const classes = useStyle();

  return (
    <>
      <style>
        {`@keyframes scaleInOut {
          0% { transform: scale(0); }
          20% { transform: scale(.6); }
          50% { transform: scale(0); }
          100% { transform: scale(0); }
        }

        @keyframes rotation {
          0% { transform: rotate(0deg) }
          100% { transform: rotate(360deg) }
        }`}
      </style>
      <div className={classes.container}>
        <div style={{ position: 'relative', width: 100, height: 100 }}>
          <div className={classes.obj} />
          <div className={classes.images}>
            <img className={classes.brand} src={UPLogo} alt='logo UP Fleet' />
            <img
              className={classes.car}
              src='data:image/png;base64,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'
              alt='carro'
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Loader;
